import { atom } from "jotai";

import { ClubSelectionStep } from "../../../types";
import {
  VerificationModalStepStateAtom,
  VerificationModalTrackEventAtom,
} from "../../stores";

export const ProceedToClubSelectionStepAtom = atom(
  null,
  (get, set, { emailOrPhone }: { emailOrPhone: string }) => {
    const track = get(VerificationModalTrackEventAtom);
    const nextStep: ClubSelectionStep = {
      step: "ClubSelection",
      backStep: "Initial",
      emailOrPhone,
    };
    set(VerificationModalStepStateAtom, nextStep);
    track?.("AuthModal.ClubSelectionStep", nextStep);
  }
);
